import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private api: ApiService) { }

  public getDashboardData(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/admin/dashboard-stats`, data, `report`)
    return rtn;
  }

  public getPaymentSummary(params:any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/table-reservation-payments${params}`, `report`)
    return rtn;
  }

  public getPaymentRecords(params:any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/table-reservation-records${params}`, `report`)
    return rtn;
  }

  public getOrderPaymentSummary(params:any): Observable<any> {
    // var rtn = this.api.get(`/api/v1/admin/order-payments?from_date=${from_date}&to_date=${to_date}&outlet_code[]=${outlet_code}&tenant_code=${tenant_code}&brand_id=${brand_id}`, `report`)
    var rtn = this.api.get(`/api/v1/admin/order-payments${params}`, `report`)
    return rtn;
  }

  public getOrderPaymentRecords(params:any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/order-records${params}`, `report`)
    return rtn;
  }

}
